import React, { useEffect, useState } from 'react'
import {
  Container,
  Typography,
  Button,
  TextField,
  // Select,
  MenuItem,
  Grid,
  Box,
  // Modal,
  Alert
} from '@mui/material';
import { Modal,Select ,Tooltip  } from 'antd'
import Checkbox from '@mui/material/Checkbox';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ModeEditOutlineIcon from '@mui/icons-material/ModeEditOutline';
import PreviewIcon from '@mui/icons-material/Preview';
import AttachmentIcon from '@mui/icons-material/Attachment';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { Table, Breadcrumb, Avatar, Drawer, Divider, Skeleton, Carousel, Image } from "antd";
import { ArrowRightOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { itemRender, onShowSizeChange } from "../../paginationfunction";
import { Link } from 'react-router-dom';
import PaymentIcon from '@mui/icons-material/Payment';
import { BaseImageUrl } from '../../../Components/BaseImageUrl';
import AddClientComp from '../../../AdminComponents/AddClientComp';
import UpdateClient from '../../../AdminComponents/UpdateClientComp';
import { Snackbar } from '@material-ui/core';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import { BaseUrl } from '../../../Components/BaseUrl';
import AddPropertyComp from '../../../AdminComponents/AddPropertyComp';
import UpdatePropertyComp from '../../../AdminComponents/UpdatePropertyComp';
import PaymentPlanCom from '../../../AdminComponents/PaymentPlanCom';
import { baseUrl, profileImageBaseUrl, propertyImagesUrl } from '../../Server/baseUrls';
import ClearIcon from '@mui/icons-material/Clear';
import './index.css'
import PulseLoader from 'react-spinners/PulseLoader'
import { MultiSelect } from "react-multi-select-component";


const { Option } = Select;

const contentStyle = {
  margin: 0,
  height: '160px',
  color: '#fff',
  lineHeight: '160px',
  textAlign: 'center',
  background: '#364d79',
};

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));
function AllProperties() {
  const [properties, setProperties] = useState([])
  const [loading, setLoading] = useState(false)
  const [isAddClientModalOpen, setIsAddClientModalOpen] = useState(false);
  const [isUpdateClientModalOpen, setIsUpdateClientModalOpen] = useState(false);

  const [openModal, setOpenModal] = useState(false);
  const [openModalForUpdate, setOpenModalForUpdate] = useState(false);


  const [updatePropertyData, setUpdatePropertyData] = useState({});
  const [recordID, setRecordID] = useState("")
  const [open, setOpen] = React.useState(false);
  const [openUpdateModal, setOpenUpdateModal] = React.useState(false);
  const [images, setImages] = useState([]);
  const [showToast, setShowToast] = React.useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [client, setClient] = useState({})
  const [profileLoading, setProfileLoading] = useState(false)
  const [country, setCountry] = useState("")
  const [status, setStatus] = useState("")
  const [search, setSearch] = useState("")
  const [owners, setOwners] = useState([])
  const [locations, setLocations] = useState([])
  const [developers, setDevelopers] = useState([])
  const [propertyTypes, setPropertyTypes] = useState([])
  const [propertyType, setPropertyType] = useState("")
  const [openPaymentPlanModal, setOpenPaymentPlanModal] = useState(false);

  const [property_id, setPropertyID] = useState("");
  const [payment_plans, setPaymentPlans] = useState([])
  const [selectedUsers, setSelectedUsers] = useState([])
const [updateproperty,setUpdateProperty] = useState({})

const [amenities, setAmenities] = useState("")
const [agents, setAgents] = useState([])
const [assignedAgentPropertyLoading,setAssignedAgentPropertyLoading] = useState(null)
const [successMessages, setSuccessMessages] = useState({});
const [selectedAgent,setSelectedAgent] = useState("")
const [selectedAgents, setSelectedAgents] = useState([]);
  const token = useSelector((state) => state.login.token);
  const axiosConfig = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`, // Include the token as a Bearer token
    },
  };

  const handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setShowToast(false);
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleUpdateOpenModal = (record) => {

    setUpdateProperty(record)
    setOpenUpdateModal(true);
    setUpdatePropertyData(record.id);
    setImages(record.images)
  };
  const handleCloseUpdateModal = () => {
    setOpenUpdateModal(false);
     
  }

  const handlePaymentPlanOpenModal = (record) => {


    setPropertyID(record.id)
    setPaymentPlans(record.property_plans)
    setOpenPaymentPlanModal(true)
  }
  const handleClosePaymentPlanModal = () => {


    setOpenPaymentPlanModal(false);

  }

  const showAddClientModal = () => {
    setIsAddClientModalOpen(true);
  };
  const handleAddClientOk = () => {
    setIsAddClientModalOpen(false);
  };
  const handleAddClientCancel = () => {
    setIsAddClientModalOpen(false);
  };

  const showUpdateClientModal = (record) => {

    setIsUpdateClientModalOpen(true);
    setUpdatePropertyData(record)
    setRecordID(record.id)
  };
  const handleUpdateClientOk = () => {
    setIsUpdateClientModalOpen(false);
  };
  const handleUpdateClientCancel = () => {
    setIsUpdateClientModalOpen(false);
  };

  const showDrawer = (record_id) => {

    setProfileLoading(true)
    setProperties({})
    setOpenDrawer(true);

    axios.get(baseUrl + "/api/owners_details/" + record_id, axiosConfig)
      .then((res) => {
        if (res.data.success) {

          setProperties(res.data.client)
          setProfileLoading(false)

        }
      })

  };
  const onCloseDrawer = () => {
    setOpenDrawer(false);
  };

  useEffect(() => {
    const page = 1;
    const perPage = 10;
    const data = { status, propertyType, owners: selectedUsers,searchTerm:search }
    fetchData(page, perPage, data);
    getOwnersAndLocations()








    // }, 1000);

  }, [])
  
  const getOwnersAndLocations = async () => {
    try {
      const url = `${baseUrl}/api/getOwnersAndLocations`;
      const response = await axios.get(url, axiosConfig);

      // console.log("***** Ownerssss ******* ", response.data.owners )
      setOwners(response.data.owners)
      setLocations(response.data.locations)
      setDevelopers(response.data.developers)
      setPropertyTypes(response.data.property_types)
      setAmenities(response.data.amenities)
      setAgents(response.data.agents)
    } catch (error) {
      console.error("err:", error);
    }

  }

  const refreshPage = () => {
    setOpenModal(false)
    setOpenUpdateModal(false)
    const page = 1;
    const perPage = 10;

    const data = { status, propertyType, owners: selectedUsers,searchTerm:search }
    fetchData(page, perPage, data);

  }

  const refreshPaymentPage = () => {
    setOpenPaymentPlanModal(false)


    const page = 1;
    const perPage = 10;

    const data = { status, propertyType, owners: selectedUsers,searchTerm:search }
    fetchData(page, perPage, data);
  }

  const handleAutocompleteChange = (event, value) => {
    const ids = value.map(option => option.id);
    setSelectedUsers(ids);

    const page = 1;
    const perPage = 10;
    const data = { status, propertyType, owners: ids,searchTerm:search }
    fetchData(page, perPage, data);
  }

  const handleClear = () => {
    setSearch('');
    const page = 1;
    const perPage = 10;
    const data = { status, propertyType, owners: selectedUsers,searchTerm:"" }
    fetchData(page, perPage, data);
  };
  const searchClient = (e) => {
    const page = 1;
    const perPage = 10;
    const search = e.target.value
    setSearch(e.target.value)
    const data = { status, propertyType, owners: selectedUsers,searchTerm:e.target.value }
    fetchData(page, perPage, data);

  }

  const setStatusFilter = (e) => {
    const page = 1;
    const perPage = 10;
    const status = e
    setStatus(status)
    const data = { status, propertyType, owners: selectedUsers,searchTerm:search }

    fetchData(page, perPage, data);
  }

  const setPropertyTypeFilter = (e) => {
   
    const page = 1;
    const perPage = 10;
    const propertyType = e
    setPropertyType(propertyType)
    const data = { status, propertyType, owners: selectedUsers,searchTerm:search }
    fetchData(page, perPage, data);

  }

  const currencyFormat = (num) => {

    return 'AED  ' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  }

  const fetchData = async (page, perPage, data) => {

    try {
      setLoading(true)
      const url = `${baseUrl}/api/getproperties?page=${page}&perPage=${perPage}`;
      const response = await axios.post(url, data, axiosConfig)
      setLoading(false);
      setProperties(response.data.properties);
    } catch (error) {
      console.error("Error:", error);
      setLoading(false)
    }
  };

  // Call fetchData function with the additional parameters
  
    
    // Call fetchData function with the additional parameters

    const handleAgentChange = (propertyId,event) =>{
   

  
      setProperties(prevState => ({
        ...prevState,
        data: prevState.data.map(property =>
          property.id === propertyId
            ? {
                ...property,
                assigned_users: event
              }
            : property
        )
      }));

      
      setAssignedAgentPropertyLoading(propertyId)
      const data = {property_id:propertyId,agents:event}
       axios.post(baseUrl + "/api/assignToAgent",data, axiosConfig)
       .then((res) =>{
        setSuccessMessages(prevMessages => ({
          ...prevMessages,
          [propertyId]: ' assigned successfully.',
        }));
        setTimeout(() => setSuccessMessages(''), 3000);
  
        
        setAssignedAgentPropertyLoading(null)
       }).catch((err) =>{
        setAssignedAgentPropertyLoading(null)

        console.log("err catched",err);
       })
    }

    const handleRemoveImage = (updatedImages) => {
  
      const updatedPropertyList = properties.data.map(property => {
      
        
          if (property.id === updatePropertyData) {
          
              return { ...property, images: updatedImages };
          }
          return property;
      });
      const updatedProperties = { ...properties, data: updatedPropertyList };
      // setUpdatedProperties(updatedPropertyList);
      setProperties(updatedProperties)
  };
      const columns = [
        // {
        //     title:"-",
        //     dataIndex: "images",
        //     key:'images',
        //     render:(text,record) =>{
        //       return(
        //         <div style={{width:'250px'}}>
        //             {record.images.length < 1? <Image
        //               preview={false}
        //               width={250}
        //               height={180}
        //               src="error"
        //               fallback="data:image/png;base64,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"
        //             />
        //             :
        //             <Carousel arrows >
        //               {record.images.map((img,index) =>(
        //                 <div key={index}>
        //                   <Image  
        //                     preview={true}
        //                     src={propertyImagesUrl+"/"+img.name}
        //                     width={250}
        //                     height={180}
        //                     />
        //                 </div>
        //                 ))
        //               }
        //           </Carousel>}
        //         </div>
        //       )
        //     }
            
        // },
        {
          title: "Unit No",
          dataIndex: "unit_no",
        },
        {
          title: "Name",
          dataIndex: "title",
        },
       
          {
            title: "Price",
            dataIndex: "price",
            render: (text, record) => 
                <>{currencyFormat(record.price)}</>

          },
          {
            title: "Type",
            dataIndex: "property_type",
          },
          {
            title: "Location",
            dataIndex: "location",
          },
          {
            title: "Developer",
            dataIndex: "developer",
          },
        {
          title: "Area",
          dataIndex: "area_size",
          render:(text,record) =>(
            <>{record.area_size}  sqft</>
          )
        
      

    },
    

    {
      title: "Status",
      dataIndex: "status"
    },
   {
    title:"Assign to",
    render: (text, record) => (
      <>
        {assignedAgentPropertyLoading == record.id ? (
          <div style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
          <PulseLoader size={10} />
          </div>
        ) : (
          <>
             <MultiSelect
                        options={agents}
                        value={record.assigned_users}
                        onChange={(newValue)=>handleAgentChange(record.id,newValue)}
                        labelledBy="Select agents"
                        overrideStrings={{
                            "selectSomeItems": "Select agents", // Custom placeholder text
                            allItemsAreSelected: "All agents are selected", // Text when all items are selected

                        }}
                        valueRenderer={(selected) => {
                          if (selected.length > 2 && selected.length < agents.length) {
                              const displaySelected = selected.slice(0, 2).map(option => option.label);
                              return `${displaySelected.join(', ')} +${selected.length - 2}`;
                          } else if (selected.length === agents.length) {
                              return "All agents are selected";
                          } else {
                              return selected.map(option => option.label).join(', ');
                          }
                      }}
                    />
          {/* <Select
          className=''
      value={record.assigned_agent && record.assigned_agent.length > 0 ? record.assigned_agent[0].agent_id : ''}
          onChange={(value) => handleAgentChange(record.id, { target: { value } })}
         
          showSearch
          style={{ width: '100%',height: '35px', lineHeight: '25px' }}
          placeholder="Select agent"
          optionFilterProp="children"
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        >
          <Option value="" style={{ padding: '8px 0' }}>&nbsp;&nbsp;&nbsp;Unassigned&nbsp;</Option>
          {agents.map(agent => (
            <Option key={agent.value} value={agent.value}>{agent.label}</Option>
          ))}
        </Select> */}
        {successMessages[record.id] && (
            <Tooltip  title={"Listing " +record.id+"  Assigned to agents "} visible={true}></Tooltip>
        )}
        </>
          // <select
          //   className='agentassign'
          //   value={record.assigned_agent && record.assigned_agent.length > 0 ? record.assigned_agent[0].agent_id : ''}
          //   onChange={(e) => handleAgentChange(record.id, e)}
          // >
          //   {record.assigned_agent.length < 1 && <option value="">Unassigned</option>}
          //   {agents.map(agent => (
          //     <option key={agent.value} value={agent.value}>{agent.label}</option>
          //   ))}
          // </select>
        )}
      </>
    )
   },
    
    {
      title: "Actions",
      render: (text, record) => (
        <div className="ms-auto" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
        
          <ModeEditOutlineIcon onClick={() => handleUpdateOpenModal(record)} onMouseOver={(e) => {
            e.currentTarget.style.cursor = 'pointer'; // Change cursor on hover
          }} style={{ marginBottom: '1rem', marginLeft: '1rem' }} />
          <DeleteOutlineIcon onMouseOver={(e) => {
            e.currentTarget.style.cursor = 'pointer'; // Change cursor on hover
          }} onClick={() => handleDelete(record.id)} style={{ marginBottom: '1rem', marginLeft: '1rem' }} />

          {/* <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            // startIcon={<AddIcon />}
                            // onClick={handleOpenModal}
                            style={{ marginBottom: '1rem' }}
                            startIcon={<ModeEditOutlineIcon />}
                            onClick={() => showUpdateClientModal(record)}
                        >
                            Update
                        </Button>
                        <Button size="small" className='ml-2'
                            variant="outlined" color="error"
                            // startIcon={<AddIcon />}
                            // onClick={handleOpenModal}
                            style={{ marginBottom: '1rem', marginLeft: '1rem' }}
                            onClick={() => handleDelete(record.id)}
                            startIcon={<DeleteOutlineIcon />}
                        >
                            Delete
                        </Button> */}



        </div>
      ),
    },
  ];

  const handleTableChange = (pagination) => {
    const page = pagination.current
    const perPage = pagination.pageSize
    const data = { status, propertyType, owners: selectedUsers,searchTerm:search }
    fetchData(page, perPage, data);
  }

  const handleDelete = (record_id) => {
    setOpen(true);
    setRecordID(record_id)


  }


  const handleClose = () => {
    setOpen(false);
  };

  const handleAgreeDelete = () => {

    axios.delete(baseUrl + "/api/properties/" + recordID, axiosConfig)
      .then((res) => {
        setOpen(false);
        if (res.data.success) {
          const page = 1
          const perPage = 10
          setTimeout(() => {
            fetchData(page, perPage, search, status, country);
            setShowToast(true)
          }, 200);


        }
      })
  }

  return (
    <Container maxWidth={'xl'} >
      <Drawer width={"50%"} title="Client Details" onClose={onCloseDrawer} open={openDrawer} style={{ marginTop: '20px' }}>
        <Skeleton loading={profileLoading} active avatar >


          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: '20px' }}>
            <Avatar size={{
              xs: 24,
              sm: 32,
              md: 40,
              lg: 64,
              xl: 80,
              xxl: 80,
            }} src={profileImageBaseUrl + "/" + client.profile_image} />
            <div>
              <p>Name    {client.name}</p>
              <p>Email    {client.email}</p>
              <p>Phone    {client.phone}</p>
              <p>Status    {client.active}</p>
            </div>
          </div>


        </Skeleton>

        <Divider />
        <Skeleton loading={profileLoading} active >
          
        </Skeleton>
      </Drawer>
      <Snackbar
        open={showToast}
        onClose={handleCloseToast}
        autoHideDuration={1500}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert severity="success" variant="filled">
          Property Number {recordID} Successfully deleted
        </Alert>
      </Snackbar>

      


      {/* <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Are you sure to delete?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            You wont able revert
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button  variant="outlined" color="error" onClick={handleClose} startIcon={<CloseIcon />}>Close</Button>
          <Button variant="outlined" onClick={handleAgreeDelete}  startIcon={<CheckIcon />}>
           Continue 
          </Button>
        </DialogActions>
      </Dialog> */}
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Delete User
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Typography gutterBottom>
            Are you sure to delete? You will not be able back
          </Typography>

        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="error" onClick={handleClose} startIcon={<CloseIcon />}>Close</Button>
          <Button variant="outlined" onClick={handleAgreeDelete} startIcon={<CheckIcon />}>
            Continue
          </Button>
        </DialogActions>
      </BootstrapDialog>

      <Modal
        width={1300} title="Payment Plan"
        open={openPaymentPlanModal}
        onCancel={handleClosePaymentPlanModal}
        aria-labelledby="add-client-modal-title"
        aria-describedby="add-client-modal-description"
        footer={null}
      >
        <Divider />
        <PaymentPlanCom xCLosePayment={() => refreshPaymentPage()} property_id={property_id} payment_plans={payment_plans} />

      </Modal>

      <Modal
        width={1300} title="Add New Listing"
        open={openModal}
        onCancel={handleCloseModal}
        aria-labelledby="add-client-modal-title"
        aria-describedby="add-client-modal-description"
        footer={null}
      >
        <Divider />
        {/* <Box sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width:'65%' ,
                        bgcolor: 'background.paper',
                        // boxShadow: 24,
                        // p: 4,
                        maxHeight:'100vh',
                        overflow:'scroll',
                        borderRadius:'0.5rem'
                    }}>
                       <Typography variant="h6" component="h2" gutterBottom>
                            Add New Property
                        </Typography> */}
        <AddPropertyComp xCloseModal={() => refreshPage()}
         owner={owners} locations={locations} developers={developers}
          property_types={propertyTypes} amenities={amenities} contacts={owners}  />
        {/* <AddClientComp xCLoseModal={() => refreshPage() } /> */}
        {/* </Box> */}
      </Modal>

      <Modal width={1300} title="Update Listing"
        open={openUpdateModal}
        onCancel={handleCloseUpdateModal}
        aria-labelledby="add-client-modal-title"
        aria-describedby="add-client-modal-description"
        footer={null}
      >
        <Divider />
        {/* <Box sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width:'65%' ,
                        bgcolor: 'background.paper',
                        // boxShadow: 24,
                        // p: 4,
                        maxHeight:'100vh',
                        overflow:'scroll',
                        borderRadius:'0.5rem'
                    }}>
                       <Typography variant="h6" component="h2" gutterBottom>
                            Update Property
                        </Typography> */}
        <UpdatePropertyComp id={updatePropertyData} xCLoseModal={() => refreshPage()}
         owner={owners} locations={locations} developers={developers}
          property_types={propertyTypes} xImages={images} updateproperty={updateproperty}
          amenities={amenities} contacts={owners}
           onRemoveImage={(updatedImages) => handleRemoveImage( updatedImages)} />
        {/* <AddClientComp xCLoseModal={() => refreshPage() } /> */}
        {/* </Box> */}
      </Modal>
      {/* <Modal width={1000} title="Add New Client" 
        open={isAddClientModalOpen} onOk={handleAddClientOk}
         onCancel={handleAddClientCancel}
        
         >
             <AddClientComp />
      
      </Modal> */}
      <div className=''>
        <Grid container spacing={2} display={'flex'} alignItems={'center'} marginBottom={'1rem'} >

          <Grid item xs={12} sm={12} md={6} xl={6} lg={6} >
            <Typography variant='h3' align='left' width={'100%'} marginBottom={'1rem'}>
              All Listings
            </Typography>
          </Grid>

          <Grid item xs={12} sm={12} md={6} xl={6} lg={6} display={'flex'} alignItems={'center'} justifyContent={'flex-end'} >
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={handleOpenModal}
              style={{ marginBottom: '1rem', backgroundColor: "black" }}
            >
              Add New Listing
            </Button>
          </Grid>

        </Grid>


        <Grid container spacing={2} display={'flex'} alignItems={'center'} marginBottom={'1rem'} >

          <Grid item xs={12} sm={12} md={6} xl={6} lg={6} >
            <Box
              sx={{
                width: '100%',
                // maxWidth: '100%',

              }}
            >
              <TextField
                label="Search"
                variant="outlined"
                value={search}
                onChange={(e) => searchClient(e)}
                fullWidth
                InputProps={{
                  endAdornment: (
                    search && (
                      <IconButton onClick={handleClear}>
                        <ClearIcon />
                      </IconButton>
                    )
                  ),
                }}
              />
            </Box>
          </Grid>

          <Grid item xs={12} sm={12} md={6} xl={6} lg={6} display={'flex'} >
            {/* <Grid item xs={3} sm={6} md={6} xl={6} lg={6} >
              <Autocomplete
                multiple
                id="checkboxes-tags-demo"
                options={owners}
                onChange={handleAutocompleteChange}
                disableCloseOnSelect
                getOptionLabel={(option) => option.name}
                renderOption={(props, option, { selected }) => (
                  <li {...props} key={option.id}>
                    <Checkbox


                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    <Avatar style={{ marginRight: '10px' }} src={profileImageBaseUrl + "/" + option.profile_image} />

                    {option.name}


                  </li>
                )}
                style={{ width: 350 }}
                renderInput={(params) => (
                  <TextField {...params} label="Select Users" placeholder="" />
                )}
              />
              
            </Grid> */}
            <Grid item xs={6} sm={6} md={6} xl={6} lg={6} >
              <Select
                // value={propertyType}
                allowClear
                  placeholder='Filter by Property type'
                onChange={(e) => {
                 
                  setPropertyTypeFilter(e)
                }}
                variant="outlined"
                fullWidth
                displayEmpty
                style={{ width: '90%',height: '55px', lineHeight: '40px' }}
              >
                  
            {propertyTypes.map((pt,index) =>(
            <Option key={pt.index} value={pt.id}>{pt.name}</Option>
          ))}
               
          

              </Select>
            </Grid>
            <Grid item xs={6} sm={6} md={6} xl={6} lg={6} >
              <Select
                // value={status}
                allowClear
                onChange={(e) => setStatusFilter(e)}
                placeholder="Filter by status"
                variant="outlined"
                fullWidth
                
                displayEmpty
                style={{ width: '100%',height: '55px', lineHeight: '40px' }}
                options={[
                  {
                    value: 'Rent',
                    label: 'Rent',
                  },
                  {
                    value: 'Sale',
                    label: 'Sale',
                  },
                  {
                    value: 'Off_plan',
                    label: 'Off-plan',
                  },
                  {
                    value: 'Ready',
                    label: 'Ready',
                  },
                  {
                    value: 'Sold',
                    label: 'Sold',
                  },
                ]}
              >
                

              </Select>
            </Grid>
          </Grid>

        </Grid>
        <Grid item xs={12} sm={12} md={6} xl={6} lg={6} >
          <Table
            onChange={handleTableChange}
            loading={loading}
            className="table-striped"
            pagination={{
              pageSizeOptions: ["10", "20", "50", "100"],
              total:
                properties?.total > 0 &&
                properties.total,
              pageSize: properties.per_page,
              current: properties.current_page,
              showTotal: (total, range) =>
                `Showing ${range[0]} to ${range[1]} of ${total} entries`,
              showSizeChanger: true,
              onShowSizeChange: onShowSizeChange,
              itemRender: itemRender,
            }}
            style={{ overflowX: "auto" }}
            columns={columns}
            // bordered
            dataSource={
              properties?.data
                ? properties?.data
                : []
            }
            rowKey={(record) => record.id}
          />
        </Grid>

      </div>

    </Container>
  )
}

export default AllProperties
